import { isEmpty } from "lodash";
import { RowType } from "PFApp/booking/types/row";
import { Row } from "PFApp/booking/types/row";
import Tooltip from "PFComponents/tooltip/tooltip";
import React, { JSX, PropsWithChildren } from "react";

import { useBookingRowsContext } from "../../context/booking_rows_context";
import { useOtherBookingsTooltipDetails } from "../hooks";
import { SidePanelRowTooltipContent } from "./side_panel_row_tooltip_content";

type SidePanelRowTooltipProps = {
  row: Row;
};

export const SidePanelRowTooltip = ({
  row: { type, key },
  children
}: PropsWithChildren<SidePanelRowTooltipProps>): JSX.Element => {
  const { bookingsByRowKey } = useBookingRowsContext();
  const isOtherRow = type === RowType.Other;

  const categoriesDuration = isOtherRow
    ? (bookingsByRowKey[key] ?? []).map(
        // eslint-disable-next-line camelcase
        ({ booking_category_id, duration }) => ({
          // eslint-disable-next-line camelcase
          id: booking_category_id as number,
          duration: duration as number
        })
      )
    : [];
  const tooltipDetails = useOtherBookingsTooltipDetails({
    categoriesDuration
  });

  return isOtherRow ? (
    <Tooltip
      content={<SidePanelRowTooltipContent tooltipDetails={tooltipDetails} />}
      disabled={isEmpty(tooltipDetails)}
      placement="top"
      appendTo="parent"
    >
      {children}
    </Tooltip>
  ) : (
    <>{children}</>
  );
};
